'use client'
import { cn } from '@mntn-dev/ui-utilities'
import { BladeCommon, type BladeCommonProps } from '../blade-common.tsx'

export type CheckoutBladeProps = BladeCommonProps & {}

export const CheckoutBlade = ({
  children,
  className,
  ...props
}: CheckoutBladeProps) => {
  return (
    <BladeCommon
      className={cn('min-h-14 pl-8 pr-6 py-3.5 gap-4', className)}
      {...props}
    >
      {children}
    </BladeCommon>
  )
}
